import { TypePopupWindowDetails } from "../types";

const filterFetchedArray = (array: any[]) => {
  const tempFetchedList = [...array];
  const fetchedList = Array.from(new Set(tempFetchedList.map((a) => a.id))).map(
    (id) => tempFetchedList.find((a) => a.id === id)
  );
  return fetchedList;
};

const popupWindow = (windowDetails: TypePopupWindowDetails) => {
  const left = window.screen.width / 2 - windowDetails.w / 2;
  const top = window.screen.height / 2 - windowDetails.h / 2;
  return window.open(
    windowDetails.url,
    windowDetails.title,
    "toolbar=no, location=no, directories=no, " +
      "status=no, menubar=no, scrollbars=no, resizable=no, " +
      `copyhistory=no, width=${windowDetails.w}, ` +
      `height=${windowDetails.h}, ` +
      `top=${top}, left=${left}`
  );
};

const mergeObjects = (target: any, source: any) => {
  // Iterate through `source` properties and if an `Object` then
  // set property to merge of `target` and `source` properties
  Object.keys(source)?.forEach((key) => {
    if (source[key] instanceof Object && key in target) {
      Object.assign(source[key], mergeObjects(target[key], source[key]));
    }
  });

  // Join `target` and modified `source`
  Object.assign(target || {}, source);
  return target;
};

const keyOptions = [
  {
    label: "_id",
    value: "_id",
    searchLabel: "_id",
    isDisabled: true,
  },
  {
    label: "title",
    value: "title",
    searchLabel: "title",
    isDisabled: true,
  },
  {
    label: "name",
    value: "name",
    searchLabel: "name",
    isDisabled: true,
  },
  {
    label: "owner",
    value: "owner",
    searchLabel: "owner",
  },
  {
    label: "project",
    value: "project",
    searchLabel: "project",
  },
  {
    label: "created",
    value: "created",
    searchLabel: "created",
  },
  {
    label: "type",
    value: "type",
    searchLabel: "type",
  },
  {
    label: "path",
    value: "path",
    searchLabel: "path",
  },
  {
    label: "modified",
    value: "modified",
    searchLabel: "modified",
  },
  {
    label: "display",
    value: "display",
    searchLabel: "display",
  },
  {
    label: "machineName",
    value: "machineName",
    searchLabel: "machineName",
  },
  {
    label: "_vid",
    value: "_vid",
    searchLabel: "_vid",
  },
  {
    label: "submissionRevisions",
    value: "submissionRevisions",
    searchLabel: "submissionRevisions",
  },
  {
    label: "revisions",
    value: "revisions",
    searchLabel: "revisions",
  },
  {
    label: "properties",
    value: "properties",
    searchLabel: "properties",
  },
  {
    label: "settings",
    value: "settings",
    searchLabel: "settings",
  },
  {
    label: "components",
    value: "components",
    searchLabel: "components",
  },
  {
    label: "submissionAccess",
    value: "submissionAccess",
    searchLabel: "submissionAccess",
  },
  {
    label: "access",
    value: "access",
    searchLabel: "access",
  },
];

const utils = {
  popupWindow,
  filterFetchedArray,
  mergeObjects,
  keyOptions,
};

export default utils;
